"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectorContext = void 0;
const tslib_1 = require("tslib");
const client_utils_1 = require("@sensenet/client-utils");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * Context that returns an Injector instance
 */
exports.InjectorContext = react_1.default.createContext(new client_utils_1.Injector());
exports.InjectorContext.displayName = 'InjectorContext';
//# sourceMappingURL=injector.js.map